import React from "react";
import Reveal from "./Reveal";
import { MANIFESTO } from "../mock";

const About = () => {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="bg-[#F6F1E8] text-[#18324F] py-24 lg:py-32"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="grid lg:grid-cols-12 gap-16">
          <div className="lg:col-span-5">
            <Reveal>
              <p className="uppercase tracking-[0.3em] text-xs font-normal text-[#B88A3B]">
                The Manifesto
              </p>
              <h2 className="font-serif-lux font-light text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-tight mt-6">
                Tailor made Marbella &amp; Costa del Sol{" "}
                <span className="italic text-[#B88A3B]">experiences</span>
              </h2>
              <div className="hairline my-10 max-w-xs" />
              <p className="text-base text-[#18324F]/70 leading-relaxed max-w-md">
                Marbella Consulting is a luxury property and lifestyle
                consultancy serving international clients who expect more than a
                transaction. They expect a standard.
              </p>
            </Reveal>
          </div>
          <div className="lg:col-span-7 flex flex-col gap-14 lg:pt-8">
            {MANIFESTO.map((m, i) => (
              <Reveal key={m.num} delay={i * 0.1}>
                <div className="grid grid-cols-[auto_1fr] gap-8 items-start border-t border-[#18324F]/10 pt-10">
                  <span className="font-serif-lux text-5xl text-[#B88A3B] leading-none">
                    {m.num}
                  </span>
                  <div>
                    <h3 className="font-serif-lux text-2xl md:text-3xl font-medium tracking-tight">
                      {m.title}
                    </h3>
                    <p className="text-base md:text-lg text-[#18324F]/65 leading-relaxed mt-3 max-w-xl">
                      {m.text}
                    </p>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
